/** Query keys for communications: messages, the SMS inbox, workflows and tasks. */
export const messagingKeys = {
  all: () => ['messaging'] as const,
  messages: () => [...messagingKeys.all(), 'messages'] as const,
  message: (id: string) => [...messagingKeys.all(), 'message', id] as const,
  recipients: (id: string, status?: string) =>
    [...messagingKeys.all(), 'recipients', id, status ?? 'all'] as const,
  audience: (input: {
    channel: string
    audienceKind: string
    listId?: string | null
    groupId?: string | null
  }) => [...messagingKeys.all(), 'audience', input] as const,
  preview: (input: unknown) => [...messagingKeys.all(), 'preview', input] as const,
  settings: () => [...messagingKeys.all(), 'settings'] as const,
  keywords: () => [...messagingKeys.all(), 'keywords'] as const,
  conversations: () => [...messagingKeys.all(), 'conversations'] as const,
  conversation: (id: string) => [...messagingKeys.all(), 'conversation', id] as const,
  subscriptions: (personId: string) => [...messagingKeys.all(), 'subscriptions', personId] as const,
  preferences: (ref: string) => [...messagingKeys.all(), 'preferences', ref] as const,
  workflows: () => [...messagingKeys.all(), 'workflows'] as const,
  workflow: (id: string) => [...messagingKeys.all(), 'workflow', id] as const,
  team: () => [...messagingKeys.all(), 'team'] as const,
  tasks: () => [...messagingKeys.all(), 'tasks'] as const,
}
